export default ({ COLORS, BREAKPOINTS }) => ({
  container: {
    display: 'flex',
    fontSize: '12px',
    lineHeight: '14px',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  },
  description: {
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: '40px',
    '& a': {
      fontWeight: 'bold',
      color: COLORS.BLUE.NORMAL,
      textDecoration: 'none'
    },
    '&:before': {
      content: '""',
      flexShrink: '0',
      height: '100%',
      width: '5px',
      backgroundColor: '#ececec',
      margin: '0 10px 0 0',
      borderRadius: '10px'
    },
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      height: 'auto',
      '&:before': {
        display: 'none'
      }
    }
  }
})
